import { render, staticRenderFns } from "./hqglCarRegBenefitStandard.vue?vue&type=template&id=6c97fe1e&scoped=true&"
import script from "./hqglCarRegBenefitStandard.vue?vue&type=script&lang=js&"
export * from "./hqglCarRegBenefitStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c97fe1e",
  null
  
)

export default component.exports